import { french as commonFrench } from '~frontend-common/i18n/french';
import { BaseTranslationKeys } from '../english';
import auth from './auth.i18n';
import error from './error.i18n';
import helpScoutBeacon from './help-scout-beacon.i18n';
import policies from './policies.i18n';
import profile from './profile.i18n';
import ui from './ui.i18n';

export const french: BaseTranslationKeys = {
  ...commonFrench,
  ...error,
  ...policies,
  ...auth,
  ...ui,
  ...profile,
  ...helpScoutBeacon,
};
